import { Label } from './ui/label';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { useLanguage } from '../contexts/LanguageContext';

export const KidMenuCard = ({ index, kid, onChange }) => {
  const { t } = useLanguage();

  const set = (field, value) => onChange(index, { ...kid, [field]: value });

  const appetizers = [
    ['pasta_cheese', t('travelForm.kidsAppPastaCheese')],
    ['pasta_napolitan', t('travelForm.kidsAppPastaNapolitan')],
    ['mozzarella_sticks', t('travelForm.kidsAppMozzarella')]
  ];

  const mains = [
    ['nuggets', t('travelForm.kidsMainNuggets')],
    ['chicken_mashed', t('travelForm.kidsMainChicken')],
    ['burger', t('travelForm.kidsMainBurger')]
  ];

  return (
    <Card className="border-2 border-primary cream-bg" data-testid={`kid-menu-card-${index}`}>
      <CardHeader className="pb-2">
        <CardTitle className="font-serif text-2xl blue-text" data-testid={`kid-menu-title-${index}`}>
          {kid.guestName ? `${t('travelForm.childLabel')}: ${kid.guestName}` : `${t('travelForm.childLabel')} ${index + 1}`}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <h3 className="font-serif text-xl font-semibold blue-text border-b-2 pb-2" style={{ borderColor: '#D4AF37' }}>
          {t('travelForm.kidsMenuTitle')}
        </h3>
        <div>
          <Label className="blue-text">{t('travelForm.kidsAppetizerQ')} *</Label>
          <RadioGroup value={kid.kidsAppetizer} onValueChange={(v) => set('kidsAppetizer', v)} className="mt-2 space-y-2">
            {appetizers.map(([val, label]) => (
              <div key={val} className="flex items-center space-x-2">
                <RadioGroupItem value={val} id={`kids-app-${val}-${index}`} data-testid={`kids-app-${val}-${index}`} />
                <Label htmlFor={`kids-app-${val}-${index}`} className="blue-text font-normal cursor-pointer">{label}</Label>
              </div>
            ))}
          </RadioGroup>
        </div>
        <div>
          <Label className="blue-text">{t('travelForm.kidsMainQ')} *</Label>
          <RadioGroup value={kid.kidsMain} onValueChange={(v) => set('kidsMain', v)} className="mt-2 space-y-2">
            {mains.map(([val, label]) => (
              <div key={val} className="flex items-center space-x-2">
                <RadioGroupItem value={val} id={`kids-main-${val}-${index}`} data-testid={`kids-main-${val}-${index}`} />
                <Label htmlFor={`kids-main-${val}-${index}`} className="blue-text font-normal cursor-pointer">{label}</Label>
              </div>
            ))}
          </RadioGroup>
        </div>
      </CardContent>
    </Card>
  );
};
